import { LuRefreshCw } from 'react-icons/lu';
import { STATE_OPTIONS } from '@/config';
import { Button, cn, Select } from '@/core/ui';
import { useContentReview } from '@/store/content-review';
import { ReviewMultiActions } from './review-multi-actions';
import { useReviewMutations } from './use-review-mutations';

type TableHeaderActionsProps = {
  onRefetch: () => void;
  isLoading: boolean;
};

export const TableHeaderActions: React.FC<TableHeaderActionsProps> = ({ onRefetch, isLoading }) => {
  const { updateLoading, deleteLoading, handleMultiDelete, handleBulkStateUpdate } = useReviewMutations();
  const clearSelectedIds = useContentReview.use.clearSelectedIds();
  const selectedIds = useContentReview.use.selectedIds();

  const onMultiDelete = async () => {
    const ids = selectedIds;
    const success = await handleMultiDelete(ids);
    if (success) {
      clearSelectedIds();
    }
  };

  const onBulkStateUpdate = async (stateValue: number) => {
    const ids = selectedIds;
    const success = await handleBulkStateUpdate(ids, stateValue);
    if (success) {
      clearSelectedIds();
    }
  };

  return (
    <div className='flex items-center gap-3'>
      <ReviewMultiActions
        selectedReviews={selectedIds}
        onDelete={onMultiDelete}
        isLoading={deleteLoading}
        onClearSelection={clearSelectedIds}
      />
      <div className='flex items-center gap-2'>
        <Select
          size='sm'
          variant='bordered'
          selectionMode='single'
          placeholder='Change state for selected'
          selectedKeys={new Set()}
          onSelectionChange={async (keys) => {
            const arr = Array.from(keys as Set<string>);
            const raw = arr[0];
            const next = raw ? Number.parseInt(raw, 10) : NaN;
            if (!Number.isFinite(next) || selectedIds.length === 0) return;
            await onBulkStateUpdate(next);
          }}
          options={STATE_OPTIONS}
          className='w-72'
          isDisabled={updateLoading || selectedIds.length === 0}
        />
        <Button variant='bordered' isIconOnly size='sm' onPress={onRefetch} isDisabled={isLoading}>
          <LuRefreshCw className={cn('size-4 text-default-600', { 'animate-spin': isLoading })} />
        </Button>
      </div>
    </div>
  );
};
